/*
 * CoreAbTestRunner
 * Not to be modified for any experiment implementation
 * New runners can be extended from this base class
 * */

import { implementAbTestRunner } from './AbTestRunnerWrapper';
import CoreXhrAbTestClass from '../CoreXhrAbTestClass';

export class CoreAbTestRunner extends CoreXhrAbTestClass {
    #privateData;
    experiments = [];

    constructor({ isAA = false } = {}) {
        super({ isAA });
    }

    experimentsSetup = (experimentsData) => {
        this.#privateData = { experimentsData };
        this.experiments = experimentsData['experimentsList'];
        this.objectType = 'AbTestRunner';
        implementAbTestRunner(this);
        this.runExperiments();
    };

    runExperiments = () => {
        if (this.experiments) {
            // Get variants for XHR experiment modules, implement, and run
            this.initTests(this.tests).then((resp) => {
                this.testVariants = resp.variants;
                this.experiments
                    .filter((test) => test.isXHR)
                    .forEach((abTestClass) => {
                        abTestClass.activeVariant = this.testVariants[abTestClass.experimentKey];
                        abTestClass.isActive = true;
                        abTestClass.implement();
                        abTestClass.run();
                    });
                this.afterRun();
            });
        } else {
            this.afterRun();
        }
    };

    afterRun() {
        // this will be implemented in the child class as needed
    }
}
